import {makeBFFApiUrl} from 'main/factories/http';

import {GetConsultProtocolsTrack} from 'domain/usecases/private/consult-protocols/get-consult-protocols-track';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RemoteGetConsultProtocolsTrack} from 'data/usecases/private/consult-protocols/remote-get-consult-protocols-track';
import {consultProtocolsFlowEndpoints} from '../../endpoints';

export const makeGetConsultProtocolsTrack = (): GetConsultProtocolsTrack =>
	new RemoteGetConsultProtocolsTrack(
		makeBFFApiUrl(consultProtocolsFlowEndpoints.consultProtocolsTrack),
		makeAuthorizeHttpClientDecorator(),
	);
